import {useEffect} from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeMedia } from '../../redux/mediaSlice';

export default function VideoPlayer({m=''}){  
  const media = useSelector((state)=> state.media.value);
  const dispatch = useDispatch();  
  useEffect(() => {    
    const loadMedia = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_PATH}media/public`, {
          params: {
            primary: true,
          },
        });
        if (res.status !== +process.env.REACT_APP_RECORD_NOT_FOUND) {
          const { error, data } = res.data;
          if (!error && typeof data === 'object') {
            dispatch(changeMedia(data));
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    };
    loadMedia();
  }, [dispatch]);

    return <div id="mediaPlayer" className="container-xxl p-2">
        <div className="container text-center">
              {media.baseUrl ? (
                <video 
                  controls 
                  width="80%" title="" height={400}
                >
                  <source src={media.baseUrl + media.path} />
                </video>
              ) : (
                <iframe
                  width="80%" 
                  height={400}                  
                  title={media.name}
                  src={media.embedUrl || media.path}
                />
              )}
        </div>
    </div>
}